import React, { useEffect, useState } from "react"
import defaultStyle from "../../styles/defaultPageStyle.module.css"
import {
  faTag,
  faFileSignature,
  faLayerGroup,
  faBoxOpen,
  faMoneyBill,
  faPen,
  faPlus,
  faPlusSquare,
  faRectangleAd,
  faRemove,
  faWarning,
  faTicket,
  faList,
  faDashboard,
  faFire,
  faFireBurner,
  faCalendar,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Button, { ButtonIcon } from "../../components/Button/Button"
import InputField from "../../components/InputField/InputField"
import GetSpace from "../../utils/space"
import { GenericFoodEntity } from "../../Objects/MealsAndDrinks/GenericFoodEntity"
import { useRegister } from "../../hooks/Register/useRegister"
import { ViewRegister } from "../../components/ViewRegister/ViewRegister"
import { TitleChildrenPath, TitlePageResponsiveIconSmall } from "../../components/Titles/Titles"
import { ListSelections } from "../../components/ListSelections/ListSelections"
import { addtionalMemory, categoryMemory, promotionsMemory } from "../../Objects/Memory/Memory"
import { selectionMemory } from "../../Objects/Memory/Memory"
import { useError } from "../../context/useErrorContext"
import { CountElements } from "../../components/CountElements/CountElements"
import { ListCanRemove } from "../../components/ListCanRemove/ListCanRemove"
import { useToggle } from "../../hooks/useToggle"
import { ToggleComponet } from "../../components/Toggle/ToggleComponet"
import { ImageLibraryPicker } from "../../components/ImageLibrary/ImageLibraryPicker"
import { SIZE } from "../../configuration/Sizes"
import THEME from "../../configuration/Theme"
import { useConfirmation } from "../../context/useConfirmationContext"
import { INPUT_SIZE } from "../../configuration/InputSize"
import { ETypeOfCharge } from "../../Enum/ETypeOfCharge"
import { GenericDropDown } from "../../components/Dropdown/Dropdown"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { PATH_MAP } from "../../configuration/PathMap"
import { CanView } from "../../components/CanView/CanView"
import { Permissions, PermissionsType } from "../../Enum/PermissionsType"
import { AddtionalEntity } from "../../Objects/Addtional/AddtionalEntity"
import { AddtionalStockEntity } from "../../Objects/Addtional/AddtionalStockEntity"
import { SelectionEntity } from "../../Objects/Selection/SelectionEntity"
import { SelectionOptionEntity } from "../../Objects/Selection/SelectionOptionEntity"
import { SelectionOptionStockEntity } from "../../Objects/Selection/SelectionOptionStockEntity"
import { useSaveSelectionOptionStock } from "../../hooks/Selection/useSaveSelectionOptionStock"
import { useSaveAdditionalStock } from "../../hooks/Addtional/useSaveAdditionalStock"
import { SelectionOptionStockPopup } from "./SelectionOptionStockPopup"
import { AdditionalStockPopup } from "./AdditionalStockPopup"
import { EEnableStatusType } from "../../Enum/EEnableStatusType"
import iconMeal from "../../assets/images/meal.jpg"
import cardStyle from "../../styles/CardCategory.module.css"
import { SimpleToggle } from "../../components/SimpleToggle/SimpleToggle"
import Animate, { AnimationTypes } from "../../components/Animate/Animate"
import { PopupHelpButton } from "../../components/Help/PopupHelpButton"
import { EProductOrderModeType } from "../../Enum/EProductOrderModeType"

interface GenericFoodPupopProbs {
  genericFoodEntity?: GenericFoodEntity
  name: string
  description: string
  coast: string
  canSelectType: boolean
  categoryId: number
  canEdite: boolean
  onRemove: () => Promise<void>
  imageAssetIds: number[]
  imageUrls: string[]
  onImagesChange: (ids: number[], urls: string[]) => void
  typeSelected?: ETypeOfCharge | ETypeOfCharge
  addtionals: AddtionalEntity[]
  selections: SelectionEntity[]
  freeAddtionals: AddtionalEntity[]
  freeAddtionalsLimit: string
  tags: string[]
  hasStockControl: boolean
  hasNeedKitchen: boolean
  hasPreparationTime: boolean
  preparationTimeMinutes: string
  isRodizioOnly: boolean
  productOrderMode: EProductOrderModeType
  reservationAllowedDays: number[]
  reservationAllowedTimes: string[]
  stockQuantity: string
  setPromotions: (e: number[]) => void
  addAddtionals: (e: number) => void
  removeAddtionals: (e: number) => void
  addFreeAddtionals: (e: number) => void
  removeFreeAddtionals: (e: number) => void
  addSelections: (e: number) => void
  removeSelections: (e: number) => void
  handleCategoryId: (e: number) => void
  handleNameChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  handleCoastChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  handleTypeSelectChange?: (e: ETypeOfCharge) => void
  handleDescriptionChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  handleFreeAddtionalsLimitChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  handleTagsChange: (e: string[]) => void
  handleHasStockControlChange: (e: boolean) => void
  handleHasNeedKitchenChange: (e: boolean) => void
  handleHasPreparationTimeChange: (e: boolean) => void
  handlePreparationTimeMinutesChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  handleIsRodizioOnlyChange: (e: boolean) => void
  handleProductOrderModeChange: (e: EProductOrderModeType) => void
  handleReservationAllowedDaysChange: (e: number[]) => void
  handleReservationAllowedTimesChange: (e: string[]) => void
  handleStockQuantityChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  customSectionBeforeTags?: React.ReactNode
  savePermission?: PermissionsType
  showCategorySelector?: boolean
  onCopy?: () => void
  associationButton?: React.ReactNode
  productType?: "meal" | "drink" | "combo"
}

export const GenericFoodPupop: React.FC<GenericFoodPupopProbs> = ({
  genericFoodEntity,
  canSelectType,
  name,
  description,
  coast,
  categoryId,
  canEdite,
  addtionals,
  selections,
  freeAddtionals,
  freeAddtionalsLimit,
  tags,
  typeSelected,
  hasStockControl,
  hasNeedKitchen,
  hasPreparationTime,
  preparationTimeMinutes,
  isRodizioOnly,
  productOrderMode,
  reservationAllowedDays,
  reservationAllowedTimes,
  stockQuantity,
  onRemove,
  handleCategoryId,
  handleNameChange,
  handleCoastChange,
  handleDescriptionChange,
  handleFreeAddtionalsLimitChange,
  handleTagsChange,
  setPromotions,
  handleTypeSelectChange,
  addAddtionals,
  removeAddtionals,
  addFreeAddtionals,
  removeFreeAddtionals,
  addSelections,
  removeSelections,
  imageAssetIds,
  imageUrls,
  onImagesChange,
  handleHasStockControlChange,
  handleHasNeedKitchenChange,
  handleHasPreparationTimeChange,
  handlePreparationTimeMinutesChange,
  handleIsRodizioOnlyChange,
  handleProductOrderModeChange,
  handleReservationAllowedDaysChange,
  handleReservationAllowedTimesChange,
  handleStockQuantityChange,
  customSectionBeforeTags,
  savePermission = Permissions.CanEditeDrinks,
  showCategorySelector = true,
  onCopy,
  associationButton,
  productType,
}) => {
  const { t } = useTranslation("genericFoodEntity")

  const navigate = useNavigate()

  const { handleEnableRegister, handleDisableRegister, isRegisterEnable } = useRegister()

  const [enableAddtionals, setEnableSelectAdditionals] = useState(false)

  const [addtionalSelectionType, setAddtionalSelectionType] = useState<"paid" | "free">("paid")

  const [enablePromotion, setPromotion] = useState(false)

  const [enableSelections, setEnableSelections] = useState(false)

  const [promotionsIds, setPromotionsIds] = useState<number[]>(genericFoodEntity?.promotionsIds || [])

  const [tagName, setTagName] = useState("")

  const [reservationTimesInput, setReservationTimesInput] = useState(reservationAllowedTimes.join(", "))

  const [isStockPopupOpen, setIsStockPopupOpen] = useState(false)

  const [optionStockConfig, setOptionStockConfig] = useState<Record<number, SelectionOptionStockEntity>>({})

  const [pendingStockOptionIds, setPendingStockOptionIds] = useState<Set<number>>(new Set())

  const { saveSelectionOptionStock } = useSaveSelectionOptionStock()

  const [isAdditionalStockPopupOpen, setIsAdditionalStockPopupOpen] = useState(false)

  const [additionalStockConfig, setAdditionalStockConfig] = useState<Record<number, AddtionalStockEntity>>({})

  const [pendingStockAdditionalIds, setPendingStockAdditionalIds] = useState<Set<number>>(new Set())

  const { saveAdditionalStock } = useSaveAdditionalStock()

  const { setNewConfirmation } = useConfirmation()

  const { setError } = useError()

  const valuesToggle = Object.mapEnumToStrings(ETypeOfCharge)

  const comboCategoryName = "combos"

  const getOptionStockConfig = (option: SelectionOptionEntity): SelectionOptionStockEntity =>
    optionStockConfig[option.id] ??
    new SelectionOptionStockEntity({
      genericFoodEntityId: genericFoodEntity?.id ?? -1,
      selectionOptionEntityId: option.id,
      hasStockControl: option.hasStockControl,
      stockQuantity: option.stockQuantity,
    })

  const updateOptionStockConfig = (option: SelectionOptionEntity, patch: Partial<SelectionOptionStockEntity>) => {
    const nextConfig = new SelectionOptionStockEntity({ ...getOptionStockConfig(option), ...patch })

    setOptionStockConfig((prev) => ({ ...prev, [option.id]: nextConfig }))

    setPendingStockOptionIds((prev) => new Set(prev).add(option.id))
  }

  const handleOptionStockControlChange = (option: SelectionOptionEntity, hasStockControl: boolean) =>
    updateOptionStockConfig(option, { hasStockControl })

  const handleOptionStockQuantityChange = (option: SelectionOptionEntity, stockQuantity: number) =>
    updateOptionStockConfig(option, { stockQuantity })

  const saveAllPendingStockChanges = async (): Promise<boolean> => {
    if (!productType || pendingStockOptionIds.size === 0) return true

    const items = [...pendingStockOptionIds]
      .map((optionId) => optionStockConfig[optionId])
      .filter((item): item is SelectionOptionStockEntity => item !== undefined)

    const success = await saveSelectionOptionStock(productType, items)

    if (success) setPendingStockOptionIds(new Set())

    return success
  }

  const allSelectionOptions = selections.flatMap((selection) => selection.options)

  const hasConfigurableSelectionOptions = allSelectionOptions.length > 0

  const outOfStockOptionsCount = allSelectionOptions.filter(
    (option) => getOptionStockConfig(option).isOutOfStock,
  ).length

  const getAdditionalStockConfig = (additional: AddtionalEntity): AddtionalStockEntity =>
    additionalStockConfig[additional.id] ??
    new AddtionalStockEntity({
      genericFoodEntityId: genericFoodEntity?.id ?? -1,
      additionalEntityId: additional.id,
      hasStockControl: additional.hasStockControl,
      stockQuantity: additional.stockQuantity,
    })

  const updateAdditionalStockConfig = (additional: AddtionalEntity, patch: Partial<AddtionalStockEntity>) => {
    const nextConfig = new AddtionalStockEntity({ ...getAdditionalStockConfig(additional), ...patch })

    setAdditionalStockConfig((prev) => ({ ...prev, [additional.id]: nextConfig }))

    setPendingStockAdditionalIds((prev) => new Set(prev).add(additional.id))
  }

  const handleAdditionalStockControlChange = (additional: AddtionalEntity, hasStockControl: boolean) =>
    updateAdditionalStockConfig(additional, { hasStockControl })

  const handleAdditionalStockQuantityChange = (additional: AddtionalEntity, stockQuantity: number) =>
    updateAdditionalStockConfig(additional, { stockQuantity })

  const saveAllPendingAdditionalStockChanges = async (): Promise<boolean> => {
    if (!productType || pendingStockAdditionalIds.size === 0) return true

    const items = [...pendingStockAdditionalIds]
      .map((additionalId) => additionalStockConfig[additionalId])
      .filter((item): item is AddtionalStockEntity => item !== undefined)

    const success = await saveAdditionalStock(productType, items)

    if (success) setPendingStockAdditionalIds(new Set())

    return success
  }

  const outOfStockAdditionalsCount = addtionals.filter(
    (additional) => getAdditionalStockConfig(additional).isOutOfStock,
  ).length

  const getSelectionDescriptionPreview = (selection: SelectionEntity) => {
    const normalizedDescription = selection.description?.trim()

    if (!normalizedDescription) {
      return t("selection:label_no_description")
    }

    return normalizedDescription.length > 25 ? `${normalizedDescription.slice(0, 25)}...` : normalizedDescription
  }

  const availableCategories = categoryMemory.listData.filter(
    (category) => category.name.trim().toLowerCase() !== comboCategoryName,
  )

  useEffect(() => {
    if (!showCategorySelector || availableCategories.length === 0) {
      return
    }

    const hasSelectedCategory = availableCategories.some((category) => category.id === categoryId)

    if (!hasSelectedCategory) {
      handleCategoryId(availableCategories[0].id)
    }
  }, [showCategorySelector, availableCategories, categoryId, handleCategoryId])

  const { selectedType, handleToggleSelection } = useToggle([
    typeSelected === ETypeOfCharge.Weight ? valuesToggle[0] : valuesToggle[0],
  ])

  useEffect(() => {
    if (typeSelected !== null && typeSelected !== undefined) {
      handleToggleSelection(true, typeSelected.toTypeOfChangeString(), () => {})
      if (handleTypeSelectChange) {
        handleTypeSelectChange(typeSelected!)
      }
    }
  }, [typeSelected])

  const handleAddPromotions = (e: number) => {
    if (promotionsIds.filter((ss) => ss === e).length > 0) {
      setError(t("promotion:label_name_aready_associate"), t("promotion:label_description_aready_associate"))
      return
    }

    const promotionIds: number[] = [...promotionsIds, promotionsMemory.findById(e)!.id]

    setPromotionsIds(promotionIds)

    setPromotions(promotionIds)

    setPromotion(false)
  }

  const handleRemovePromotion = (e: number) => {
    const promotionIds: number[] = [...promotionsIds.filter((ss) => ss !== e)]

    setPromotionsIds(promotionIds)

    setPromotions(promotionIds)
  }

  const handleChangeType = (e: string[]) => {
    if (handleTypeSelectChange)
      handleTypeSelectChange(
        e[0] === ETypeOfCharge.Weight.toTypeOfChangeString() ? ETypeOfCharge.Weight : ETypeOfCharge.FixedValue,
      )
  }

  const handleAddTag = () => {
    const normalizedTag = tagName.trim().replace(/\s+/g, " ")

    if (normalizedTag.length === 0) {
      return
    }

    if (tags.some((e) => e.toLowerCase() === normalizedTag.toLowerCase())) {
      setError(t("general:label_invalid"), t("label_tag_aready_associate"))
      return
    }

    if (normalizedTag.length > 15) {
      setError(t("general:label_invalid"), t("label_tag_max_length"))
      return
    }

    if (tags.length >= 3) {
      setError(t("general:label_invalid"), t("label_tag_max_count"))
      return
    }

    handleTagsChange([...tags, normalizedTag])
    setTagName("")
  }

  const handleRemoveTag = (tag: string) => {
    handleTagsChange(tags.filter((e) => e !== tag))
  }

  const dayOptions = [
    { value: 0, label: t("label_reservation_day_sun") },
    { value: 1, label: t("label_reservation_day_mon") },
    { value: 2, label: t("label_reservation_day_tue") },
    { value: 3, label: t("label_reservation_day_wed") },
    { value: 4, label: t("label_reservation_day_thu") },
    { value: 5, label: t("label_reservation_day_fri") },
    { value: 6, label: t("label_reservation_day_sat") },
  ]

  useEffect(() => {
    setReservationTimesInput((reservationAllowedTimes ?? []).map((time) => time.toShortTime()).join(", "))
  }, [reservationAllowedTimes])

  if (showCategorySelector && availableCategories.length == 0) {
    return (
      <>
        <div className={defaultStyle.divisionBar}></div>

        <TitlePageResponsiveIconSmall
          title={t("label_need_category")}
          boxShadow="none"
          children={
            <ButtonIcon
              size="small"
              typeButton="button"
              icon={faPlus}
              sizeNumber={SIZE.buttonExpandIcon}
              bgColor={THEME.colors.buttonBGPlusColor}
              iconColor={THEME.colors.buttonFGPlusColor}
              onClick={() => navigate(`${PATH_MAP.CATEGORY_PAGE}?enableCreate=true`)}
              descriptionKey="interactionDescriptions:pages.products.genericFoodPupop.button.navigateEnableCreateTrue"
            />
          }
        />

        <div className={defaultStyle.divisionBar}></div>
      </>
    )
  }

  return (
    <>
      <GetSpace top={5} />

      <div className="p-2">
        <ImageLibraryPicker
          disabled={canEdite}
          selectedIds={imageAssetIds}
          selectedUrls={imageUrls}
          onChange={onImagesChange}
        />

        <div className={defaultStyle.divisionBar}></div>

        {showCategorySelector && (
          <>
            <GenericDropDown
              data={availableCategories.map((e) => e.name)}
              initialState={availableCategories.find((e) => e.id === categoryId)?.name ?? availableCategories[0]?.name}
              handlerFuncion={(e) =>
                handleCategoryId(
                  availableCategories.find((category) => category.name === e.target.value)?.id ??
                    availableCategories[0]?.id ??
                    0,
                )
              }
              disable={canEdite}
              descriptionKey="interactionDescriptions:pages.products.genericFoodPupop.select.select"
            />

            <GetSpace top={5} />
          </>
        )}

        <ToggleComponet
          canSelectType={canSelectType}
          selectedType={selectedType}
          valuesToggle={valuesToggle}
          handleChangeType={handleChangeType}
          handleToggleSelection={handleToggleSelection}
          disable={canEdite}
          descriptionKey="interactionDescriptions:pages.products.genericFoodPupop.toggle.toggle"
        />

        {canSelectType && <div className={defaultStyle.divisionBar}></div>}

        <InputField
          value={name}
          type="text"
          maxLength={INPUT_SIZE.MEALS.name}
          icon={faFileSignature}
          placeholder={t("label_name_place_holder")}
          onInvalidMessage={t("label_name_onInvalidMessage")}
          onChange={handleNameChange}
          required
          disable={canEdite}
          descriptionKey="interactionDescriptions:pages.products.genericFoodPupop.input.namePlaceHolder"
        />

        <GetSpace top={10} />

        <InputField
          type="number"
          maxLength={INPUT_SIZE.MEALS.value}
          placeholder={t("label_coast_place_holder")}
          onInvalidMessage={t("label_coast_onInvalidMessage")}
          icon={faMoneyBill}
          value={coast.toString()}
          onChange={handleCoastChange}
          required
          disable={canEdite}
          descriptionKey="interactionDescriptions:pages.products.genericFoodPupop.input.coastPlaceHolder"
        />

        <GetSpace top={10} />

        <InputField
          type="text"
          maxLength={INPUT_SIZE.MEALS.description}
          placeholder={t("label_description_place_holder")}
          onInvalidMessage={t("label_description_onInvalidMessage")}
          icon={faPen}
          value={description}
          onChange={handleDescriptionChange}
          disable={canEdite}
          descriptionKey="interactionDescriptions:pages.products.genericFoodPupop.input.descriptionPlaceHolder"
        />

        <div className={defaultStyle.divisionBar}></div>

        <SimpleToggle
          title={t("label_has_need_kitchen")}
          value={hasNeedKitchen}
          boxShadow="none"
          disabled={canEdite}
          onChange={(e) => handleHasNeedKitchenChange(e)}
          descriptionKey="interactionDescriptions:pages.products.genericFoodPupop.toggle.hasNeedKitchen"
        />

        <div className={defaultStyle.divisionBar}></div>

        <SimpleToggle
          title={t("label_has_preparation_time")}
          value={hasPreparationTime}
          boxShadow="none"
          disabled={canEdite}
          onChange={(e) => handleHasPreparationTimeChange(e)}
          descriptionKey="interactionDescriptions:pages.products.genericFoodPupop.toggle.hasPreparationTime"
        />

        {hasPreparationTime && (
          <>
            <GetSpace top={10} />

            <InputField
              type="number"
              placeholder={t("label_preparation_time_minutes_placeholder")}
              onInvalidMessage={t("label_preparation_time_minutes_invalid")}
              icon={faFireBurner}
              value={preparationTimeMinutes}
              onChange={handlePreparationTimeMinutesChange}
              required
              disable={canEdite}
              descriptionKey="interactionDescriptions:pages.products.genericFoodPupop.input.preparationTimeMinutesPlaceholder"
            />
          </>
        )}

        <div className={defaultStyle.divisionBar}></div>

        <SimpleToggle
          title={t("label_has_stock_control")}
          value={hasStockControl}
          boxShadow="none"
          disabled={canEdite}
          onChange={(e) => handleHasStockControlChange(e)}
          descriptionKey="interactionDescriptions:pages.products.genericFoodPupop.toggle.hasStockControl"
        />

        {hasStockControl && (
          <>
            <GetSpace top={10} />

            <InputField
              type="number"
              placeholder={t("label_stock_quantity_place_holder")}
              onInvalidMessage={t("label_stock_quantity_onInvalidMessage")}
              icon={faBoxOpen}
              value={stockQuantity}
              onChange={handleStockQuantityChange}
              required
              disable={canEdite}
              descriptionKey="interactionDescriptions:pages.products.genericFoodPupop.input.stockQuantityPlaceHolder"
            />
          </>
        )}

        <GetSpace top={5} />

        <div className={defaultStyle.divisionBar}></div>

        <SimpleToggle
          title={t("label_is_rodizio_only")}
          value={isRodizioOnly}
          boxShadow="none"
          disabled={canEdite}
          onChange={(e) => handleIsRodizioOnlyChange(e)}
          descriptionKey="interactionDescriptions:pages.products.genericFoodPupop.toggle.isRodizioOnly"
        />

        <p className="px-1 mt-1 text-xs text-gray-500">{t("label_is_rodizio_only_help")}</p>

        <div className={defaultStyle.divisionBar}></div>

        <TitleChildrenPath
          title={t("label_order_mode_title")}
          icon={faCalendar}
          iconColor={THEME.colors.iconBGColor}
          boxShadow="none"
          subtitleChildren={
            <PopupHelpButton
              helpKey="pages.products.genericfoodpupop.4"
              title={t("helpPopup:sections.genericFood.orderMode.title")}
              description={t("helpPopup:sections.genericFood.orderMode.description")}
              bullets={t("helpPopup:sections.genericFood.orderMode.bullets", { returnObjects: true }) as string[]}
            />
          }
          children={
            <div className="px-1 mt-5 space-y-3">
              <GenericDropDown
                data={[
                  { label: t("label_order_mode_immediate_only"), value: String(EProductOrderModeType.ImmediateOnly) },
                  {
                    label: t("label_order_mode_reservation_only"),
                    value: String(EProductOrderModeType.ReservationOnly),
                  },
                  {
                    label: t("label_order_mode_immediate_and_reservation"),
                    value: String(EProductOrderModeType.ImmediateAndReservation),
                  },
                ]}
                disable={canEdite}
                initialState={String(productOrderMode)}
                handlerFuncion={(event) =>
                  handleProductOrderModeChange(Number(event.target.value) as EProductOrderModeType)
                }
                descriptionKey="interactionDescriptions:pages.products.genericFoodPupop.select.select2"
              />

              {productOrderMode !== EProductOrderModeType.ImmediateOnly && (
                <div className="rounded-md border border-orange-100 bg-orange-50/30 p-3 space-y-3">
                  <div>
                    <p className="mb-2 text-xs font-semibold text-slate-600">{t("label_reservation_days_title")}</p>

                    <div className="flex flex-wrap gap-2">
                      {dayOptions.map((day) => {
                        const selected = reservationAllowedDays.includes(day.value)

                        return (
                          <button
                            key={day.value}
                            type="button"
                            disabled={canEdite}
                            onClick={() =>
                              handleReservationAllowedDaysChange(
                                selected
                                  ? reservationAllowedDays.filter((e) => e !== day.value)
                                  : [...reservationAllowedDays, day.value].sort((a, b) => a - b),
                              )
                            }
                            className={`rounded-md px-3 py-1 text-xs font-bold ${selected ? "bg-orange-600 text-white" : "bg-gray-100 text-gray-600"}`}
                            data-interaction-description-key="interactionDescriptions:pages.products.genericFoodPupop.button.handleReservationAllowedDaysChangeSelectedReservationAllowed"
                          >
                            {day.label}
                          </button>
                        )
                      })}
                    </div>
                  </div>

                  <div>
                    <p className="mb-2 text-xs font-semibold text-slate-600">{t("label_reservation_times_title")}</p>
                    <div className="relative flex items-center rounded-xl border border-gray-300 bg-white ring-2 ring-gray-200 transition-all duration-200 focus-within:border-orange-400 focus-within:ring-orange-500">
                      <div className="pl-3 pr-2 text-gray-700">
                        <FontAwesomeIcon icon={faLayerGroup} />
                      </div>

                      <input
                        type="text"
                        placeholder={t("label_reservation_times_placeholder")}
                        value={reservationTimesInput}
                        onChange={(event) => setReservationTimesInput(event.target.value)}
                        onBlur={() =>
                          handleReservationAllowedTimesChange(
                            reservationTimesInput
                              .split(",")
                              .map((e) => e.trim())
                              .filter((e) => e.length > 0),
                          )
                        }
                        disabled={canEdite}
                        className="min-w-0 flex-1 bg-transparent py-2 pr-3 text-gray-800 outline-none placeholder:text-gray-400 disabled:text-gray-400"
                        data-interaction-description-key="interactionDescriptions:pages.products.genericFoodPupop.input.reservationTimesPlaceholder"
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          }
        />

        {customSectionBeforeTags && (
          <>
            <div className={defaultStyle.divisionBar}></div>
            {customSectionBeforeTags}
          </>
        )}

        <div className={defaultStyle.divisionBar}></div>

        <TitleChildrenPath
          title={t("title_add_tags")}
          icon={faTicket}
          iconColor={THEME.colors.iconBGColor}
          boxShadow="none"
          subtitleChildren={
            <div className="flex items-center gap-2">
              <PopupHelpButton
                helpKey="pages.products.genericfoodpupop.1"
                title={t("helpPopup:sections.genericFood.tags.title")}
                description={t("helpPopup:sections.genericFood.tags.description")}
                bullets={t("helpPopup:sections.genericFood.tags.bullets", { returnObjects: true }) as string[]}
              />

              <ButtonIcon
                typeButton="button"
                icon={faPlus}
                disabled={canEdite}
                sizeNumber={SIZE.buttonExpandIcon}
                bgColor={THEME.colors.buttonBGSaveColor}
                iconColor={THEME.colors.buttonFGPlusColor}
                onClick={handleAddTag}
                descriptionKey="interactionDescriptions:pages.products.genericFoodPupop.button.handleAddTag"
              />
            </div>
          }
          children={
            <div className="px-1">
              <GetSpace top={20} />

              <InputField
                type="text"
                placeholder={t("label_tag_place_holder")}
                onInvalidMessage={t("label_tag_on_invalid_message")}
                icon={faTag}
                value={tagName}
                onChange={(e) => setTagName(e.target.value)}
                disable={canEdite}
                maxLength={15}
                descriptionKey="interactionDescriptions:pages.products.genericFoodPupop.input.tagPlaceHolder"
              />

              <GetSpace top={20} />

              <CountElements count={tags.length} title={t("label_tags_count")} boxShadow="none" />

              {tags.map((tag, index) => (
                <React.Fragment key={tag}>
                  <GetSpace top={5} />

                  <ListCanRemove
                    key={index}
                    disable={canEdite}
                    color={THEME.colors.cardPromotionsLinked}
                    icon={faTag}
                    onRemove={() => handleRemoveTag(tag)}
                    data={{
                      id: index,
                      title: tag,
                      linkImage: "",
                      index: index,
                      dataFilter: [tag, t("label_tag_card_description")],
                    }}
                  />
                </React.Fragment>
              ))}
            </div>
          }
        />
      </div>

      <div className={defaultStyle.divisionBar}></div>

      <TitleChildrenPath
        title={t("title_configurable_selections")}
        icon={faList}
        iconColor={THEME.colors.iconBGColor}
        boxShadow="none"
        subtitleChildren={
          <div className="flex items-center gap-2 mr-1.5 mt-1.5">
            <PopupHelpButton
              helpKey="pages.products.genericfoodpupop.2"
              title={t("helpPopup:sections.genericFood.selections.title")}
              description={t("helpPopup:sections.genericFood.selections.description")}
              bullets={t("helpPopup:sections.genericFood.selections.bullets", { returnObjects: true }) as string[]}
            />

            <ButtonIcon
              size="small"
              typeButton="button"
              icon={faPlus}
              disabled={canEdite}
              sizeNumber={SIZE.buttonExpandIcon}
              bgColor={THEME.colors.buttonBGPlusColor}
              iconColor={THEME.colors.buttonFGPlusColor}
              onClick={() => setEnableSelections(true)}
              descriptionKey="interactionDescriptions:pages.products.genericFoodPupop.button.setEnableSelectionsTrue"
            />

            {productType && genericFoodEntity && genericFoodEntity.id !== -1 && hasConfigurableSelectionOptions && (
              <div className="relative inline-flex">
                <ButtonIcon
                  size="small"
                  typeButton="button"
                  icon={faBoxOpen}
                  sizeNumber={SIZE.buttonExpandIcon}
                  bgColor={THEME.colors.buttonBGSaveColor}
                  iconColor={THEME.colors.buttonFGSaveColor}
                  ariaLabel={t("label_option_stock_configure")}
                  onClick={() => setIsStockPopupOpen(true)}
                  descriptionKey="interactionDescriptions:pages.products.genericFoodPupop.button.openSelectionOptionStockPopup"
                />

                {outOfStockOptionsCount > 0 && (
                  <span
                    className="pointer-events-none absolute -right-1.5 -top-1.5 inline-flex h-5 min-w-[20px] items-center justify-center rounded-full bg-red-600 px-1 text-[11px] font-extrabold text-white shadow"
                    aria-label={t("label_option_stock_configure_badge_aria", { count: outOfStockOptionsCount })}
                  >
                    {outOfStockOptionsCount}
                  </span>
                )}
              </div>
            )}
          </div>
        }
        children={
          <>
            <CountElements count={selections.length} title={t("label_selections_count")} boxShadow="none" />

            {selections.map((e, index) => (
              <div key={index} className="px-2">
                <GetSpace top={5} />

                <div
                  className={`group relative overflow-hidden rounded-lg p-2 shadow-sm transition-all duration-300 hover:-translate-y-0.5 hover:shadow-md ${
                    e.status === EEnableStatusType.Inactive
                      ? "border border-red-200 bg-gradient-to-br from-red-50 via-white to-red-100/40"
                      : "border border-orange-100 bg-gradient-to-br from-white via-orange-50 to-orange-100/40"
                  }`}
                >
                  <div className="flex items-start justify-between gap-4">
                    <div className="min-w-0 flex-1">
                      <div className={cardStyle.cardCollum}>
                        <span
                          className={`${cardStyle.cardTitle1} block truncate text-base font-semibold text-gray-800`}
                        >
                          {e.name}
                        </span>
                      </div>

                      <div className="mt-2 flex flex-wrap items-center gap-2">
                        {e.status === EEnableStatusType.Inactive && (
                          <span className="inline-flex items-center rounded-full bg-red-100 px-2 py-1 text-[11px] font-semibold text-red-700">
                            Inativa
                          </span>
                        )}

                        <span className="inline-flex items-center rounded-full bg-white px-3 py-1 text-xs font-medium text-orange-700">
                          {t("label_options_available", { count: e.options.length })}
                        </span>

                        <span className="inline-flex items-center rounded-full bg-sky-100 px-2 py-1 text-[11px] font-semibold text-sky-700">
                          {e.allowMultiple
                            ? t("selection:label_multiple_choice_badge")
                            : t("selection:label_single_choice_badge")}
                        </span>

                        {e.hasMaximumSelectionsLimit && (
                          <span className="inline-flex items-center rounded-full bg-purple-100 px-2 py-1 text-[11px] font-semibold text-purple-700">
                            {t("selection:label_maximum_selections_badge", { count: e.maximumSelectionsLimit })}
                          </span>
                        )}

                        {e.freeOptionsLimit > 0 && (
                          <span className="inline-flex items-center rounded-full bg-lime-100 px-2 py-1 text-[11px] font-semibold text-lime-700">
                            {t("selection:label_free_options_limit_badge", { count: e.freeOptionsLimit })}
                          </span>
                        )}
                      </div>
                    </div>

                    <button
                      type="button"
                      disabled={canEdite}
                      onClick={() => removeSelections(e.id)}
                      className="inline-flex items-center justify-center rounded-lg border border-red-200 bg-red-600 px-3 py-2 text-xs font-semibold text-white transition-all duration-200 hover:border-red-300 hover:bg-red-100 hover:text-red-700 disabled:cursor-not-allowed disabled:border-gray-200 disabled:bg-gray-100 disabled:text-gray-400"
                      data-interaction-description-key="interactionDescriptions:pages.products.genericFoodPupop.button.removeSelectionsEId"
                    >
                      {t("buttons:button_remove")}
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </>
        }
      />

      {isStockPopupOpen && productType && genericFoodEntity && genericFoodEntity.id !== -1 && (
        <SelectionOptionStockPopup
          selections={selections}
          canEdite={canEdite}
          pendingCount={pendingStockOptionIds.size}
          getOptionStockConfig={getOptionStockConfig}
          onOptionStockControlChange={handleOptionStockControlChange}
          onOptionStockQuantityChange={handleOptionStockQuantityChange}
          onSaveAll={saveAllPendingStockChanges}
          onClose={() => setIsStockPopupOpen(false)}
        />
      )}

      <div className={defaultStyle.divisionBar}></div>

      <TitleChildrenPath
        title={t("title_add_additionals")}
        icon={faFire}
        iconColor={THEME.colors.iconBGColor}
        boxShadow="none"
        subtitleChildren={
          <div className="flex items-center gap-2 mr-1.5 mt-1.5">
            <PopupHelpButton
              helpKey="pages.products.genericfoodpupop.3"
              title={t("helpPopup:sections.genericFood.paidAdditionals.title")}
              description={t("helpPopup:sections.genericFood.paidAdditionals.description")}
              bullets={t("helpPopup:sections.genericFood.paidAdditionals.bullets", { returnObjects: true }) as string[]}
            />

            <ButtonIcon
              size="small"
              typeButton="button"
              icon={faPlus}
              disabled={canEdite}
              sizeNumber={SIZE.buttonExpandIcon}
              bgColor={THEME.colors.buttonBGPlusColor}
              iconColor={THEME.colors.buttonFGPlusColor}
              onClick={() => {
                setAddtionalSelectionType("paid")
                setEnableSelectAdditionals(true)
              }}
              descriptionKey="interactionDescriptions:pages.products.genericFoodPupop.button.faPlus"
            />

            {productType && genericFoodEntity && genericFoodEntity.id !== -1 && addtionals.length > 0 && (
              <div className="relative inline-flex">
                <ButtonIcon
                  size="small"
                  typeButton="button"
                  icon={faBoxOpen}
                  sizeNumber={SIZE.buttonExpandIcon}
                  bgColor={THEME.colors.buttonBGSaveColor}
                  iconColor={THEME.colors.buttonFGSaveColor}
                  ariaLabel={t("label_additional_stock_configure")}
                  onClick={() => setIsAdditionalStockPopupOpen(true)}
                  descriptionKey="interactionDescriptions:pages.products.genericFoodPupop.button.openAdditionalStockPopup"
                />

                {outOfStockAdditionalsCount > 0 && (
                  <span
                    className="pointer-events-none absolute -right-1.5 -top-1.5 inline-flex h-5 min-w-[20px] items-center justify-center rounded-full bg-red-600 px-1 text-[11px] font-extrabold text-white shadow"
                    aria-label={t("label_additional_stock_configure_badge_aria", { count: outOfStockAdditionalsCount })}
                  >
                    {outOfStockAdditionalsCount}
                  </span>
                )}
              </div>
            )}
          </div>
        }
        children={
          <>
            <CountElements count={addtionals.length} title={t("label_additionals_count")} boxShadow="none" />

            {addtionals.map((e, index) => (
              <div key={index} className="px-2">
                <GetSpace top={5} />

                <Animate type={AnimationTypes.fadeInTraslate} duration="1.5s">
                  <div
                    className={`w-full flex flex-row items-center gap-3 rounded-lg p-2 shadow-sm transition-all duration-300 hover:-translate-y-0.5 hover:shadow-md ${
                      e.status === EEnableStatusType.Inactive
                        ? "border border-red-200 bg-gradient-to-br from-red-50 via-white to-red-100/40"
                        : "border border-orange-100 bg-gradient-to-br from-white via-orange-50 to-orange-100/40"
                    }`}
                  >
                    {e.iconUrl.length > 0 ? (
                      <img
                        src={e.iconUrl.toClientRequest()}
                        className="w-10 h-10 min-w-[40px] min-h-[40px] object-cover rounded-[5px] flex-shrink-0"
                      />
                    ) : (
                      <img
                        src={iconMeal}
                        className="w-10 h-10 min-w-[40px] min-h-[40px] object-cover rounded-[5px] flex-shrink-0"
                      />
                    )}

                    <div className={cardStyle.cardContent}>
                      <div className={cardStyle.cardContent}>
                        <div className={cardStyle.cardCollum}>
                          <span className={cardStyle.cardTitle1}>{e.name}</span>

                          <span
                            className={cardStyle.cardTxtBody1}
                            style={{ padding: "0px 0px 0px 10px", width: "100%" }}
                          >
                            {e.value.toString().toMoney()}
                          </span>

                          {e.status === EEnableStatusType.Inactive && (
                            <span className="mt-1 inline-flex items-center rounded-full bg-red-100 px-2 py-1 text-[11px] font-semibold text-red-700">
                              Inativo
                            </span>
                          )}
                        </div>

                        <ButtonIcon
                          sizeNumber={SIZE.buttonExpandIcon}
                          border="solid 2px #ff0000"
                          bgColor={THEME.colors.white}
                          iconColor={THEME.colors.buttonFGCloseColor}
                          icon={faRemove}
                          disabled={canEdite}
                          onClick={() => removeAddtionals(e.id)}
                          size="small"
                          descriptionKey="interactionDescriptions:pages.products.genericFoodPupop.button.removeAddtionalsEId"
                        />
                      </div>
                    </div>
                  </div>
                </Animate>
              </div>
            ))}
          </>
        }
      />

      {isAdditionalStockPopupOpen && productType && genericFoodEntity && genericFoodEntity.id !== -1 && (
        <AdditionalStockPopup
          addtionals={addtionals}
          canEdite={canEdite}
          pendingCount={pendingStockAdditionalIds.size}
          getAdditionalStockConfig={getAdditionalStockConfig}
          onAdditionalStockControlChange={handleAdditionalStockControlChange}
          onAdditionalStockQuantityChange={handleAdditionalStockQuantityChange}
          onSaveAll={saveAllPendingAdditionalStockChanges}
          onClose={() => setIsAdditionalStockPopupOpen(false)}
        />
      )}

      <div className={defaultStyle.divisionBar}></div>

      <TitleChildrenPath
        title={t("title_free_additionals")}
        icon={faFireBurner}
        iconColor={THEME.colors.iconBGColor}
        boxShadow="none"
        subtitleChildren={
          <div className="flex items-center gap-2">
            <PopupHelpButton
              helpKey="pages.products.genericfoodpupop.4"
              title={t("helpPopup:sections.genericFood.freeAdditionals.title")}
              description={t("helpPopup:sections.genericFood.freeAdditionals.description")}
              bullets={t("helpPopup:sections.genericFood.freeAdditionals.bullets", { returnObjects: true }) as string[]}
            />

            <ButtonIcon
              size="small"
              typeButton="button"
              icon={faPlus}
              disabled={canEdite}
              sizeNumber={SIZE.buttonExpandIcon}
              bgColor={THEME.colors.buttonBGPlusColor}
              iconColor={THEME.colors.buttonFGPlusColor}
              onClick={() => {
                setAddtionalSelectionType("free")
                setEnableSelectAdditionals(true)
              }}
              descriptionKey="interactionDescriptions:pages.products.genericFoodPupop.button.faPlus2"
            />
          </div>
        }
        children={
          <div className="px-2">
            <GetSpace top={20} />

            <InputField
              type="number"
              placeholder={t("label_free_additionals_limit_placeholder")}
              onInvalidMessage={t("label_free_additionals_limit_invalid")}
              icon={faMoneyBill}
              value={freeAddtionalsLimit}
              onChange={handleFreeAddtionalsLimitChange}
              disable={canEdite}
              descriptionKey="interactionDescriptions:pages.products.genericFoodPupop.input.freeAdditionalsLimitPlaceholder"
            />

            <GetSpace top={20} />

            <CountElements count={freeAddtionals.length} title={t("label_free_additionals_count")} boxShadow="none" />

            {freeAddtionals.map((e, index) => {
              return (
                <div key={index} style={{ padding: "0px 5px" }}>
                  <GetSpace top={5} />

                  <div
                    className={`w-full flex flex-row items-center gap-3 rounded-lg p-2 shadow-sm transition-all duration-300 hover:-translate-y-0.5 hover:shadow-md ${
                      e.status === EEnableStatusType.Inactive
                        ? "border border-red-200 bg-gradient-to-br from-red-50 via-white to-red-100/40"
                        : "border border-orange-100 bg-gradient-to-br from-white via-orange-50 to-orange-100/40"
                    }`}
                  >
                    {e.iconUrl.length > 0 ? (
                      <img
                        src={e.iconUrl.toClientRequest()}
                        className="w-10 h-10 min-w-[40px] min-h-[40px] object-cover rounded-[5px] flex-shrink-0"
                      />
                    ) : (
                      <img
                        src={iconMeal}
                        className="w-10 h-10 min-w-[40px] min-h-[40px] object-cover rounded-[5px] flex-shrink-0"
                      />
                    )}

                    <div className={cardStyle.cardContent}>
                      <div className={cardStyle.cardContent}>
                        <div className={cardStyle.cardCollum}>
                          <span className={cardStyle.cardTitle1}>{e.name}</span>

                          {e.status === EEnableStatusType.Inactive && (
                            <span className="mt-1 inline-flex items-center rounded-full bg-red-100 px-2 py-1 text-[11px] font-semibold text-red-700">
                              Inativo
                            </span>
                          )}
                        </div>

                        <ButtonIcon
                          sizeNumber={SIZE.buttonExpandIcon}
                          border="solid 2px #ff0000"
                          bgColor={THEME.colors.white}
                          iconColor={THEME.colors.buttonFGCloseColor}
                          icon={faRemove}
                          disabled={canEdite}
                          onClick={() => removeFreeAddtionals(e.id)}
                          size="small"
                          descriptionKey="interactionDescriptions:pages.products.genericFoodPupop.button.removeFreeAddtionalsEId"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        }
      />

      <div className={defaultStyle.divisionBar}></div>

      <TitleChildrenPath
        title={t("promotion:label_add_promotion_associate")}
        icon={faRectangleAd}
        boxShadow="none"
        subtitleChildren={
          <div className="flex items-center gap-2">
            <PopupHelpButton
              helpKey="pages.products.genericfoodpupop.5"
              title={t("helpPopup:sections.genericFood.promotions.title")}
              description={t("helpPopup:sections.genericFood.promotions.description")}
              bullets={t("helpPopup:sections.genericFood.promotions.bullets", { returnObjects: true }) as string[]}
            />

            <ButtonIcon
              size="small"
              typeButton="button"
              icon={faPlus}
              disabled={canEdite}
              sizeNumber={SIZE.buttonExpandIcon}
              bgColor={THEME.colors.buttonBGPlusColor}
              iconColor={THEME.colors.buttonFGPlusColor}
              onClick={() => setPromotion(true)}
              descriptionKey="interactionDescriptions:pages.products.genericFoodPupop.button.setPromotionTrue"
            />
          </div>
        }
        children={
          <>
            <GetSpace top={5} />

            <div>
              {promotionsIds.length > 0 && (
                <>
                  <CountElements
                    count={promotionsIds.length}
                    title={t("promotion:label_promotion_associated")}
                    boxShadow={"none"}
                  />

                  <GetSpace top={5} />

                  {promotionsIds.map((e, index) => {
                    const promotion = promotionsMemory.findById(e)
                    const isInactive = promotion?.status === EEnableStatusType.Inactive

                    if (!promotion) {
                      return null
                    }

                    return (
                      <React.Fragment key={index}>
                        <GetSpace top={3} />

                        <div
                          className={`rounded-lg p-2 shadow-sm transition-all duration-300 hover:-translate-y-0.5 hover:shadow-md ${
                            isInactive
                              ? "border border-red-200 bg-gradient-to-br from-red-50 via-white to-red-100/40"
                              : "border border-orange-100 bg-gradient-to-br from-white via-orange-50 to-orange-100/40"
                          }`}
                        >
                          <div className="flex items-center gap-2">
                            <span className={cardStyle.cardTitle1} style={{ width: "100%" }}>
                              {promotion.name}
                            </span>

                            {isInactive && (
                              <span className="inline-flex items-center rounded-full bg-red-400 px-2 py-1 text-[11px] font-bold text-white-100">
                                Inativa
                              </span>
                            )}

                            <ButtonIcon
                              size="small"
                              icon={faRemove}
                              disabled={canEdite}
                              sizeNumber={SIZE.buttonExpandIcon}
                              bgColor={THEME.colors.buttonBGRemoveColor}
                              iconColor={THEME.colors.buttonFGRemoveColor}
                              onClick={() => handleRemovePromotion(e)}
                              descriptionKey="interactionDescriptions:pages.products.genericFoodPupop.button.handleRemovePromotionE"
                            />
                          </div>
                        </div>
                      </React.Fragment>
                    )
                  })}
                </>
              )}
            </div>
          </>
        }
      />

      <div className={defaultStyle.divisionBar}></div>

      <section className={defaultStyle.buttonsController}>
        <CanView permission={savePermission}>
          <Button
            label={t("buttons:button_save")}
            typeButton="submit"
            type="primary"
            size="medium"
            bgColor={THEME.colors.buttonBGSaveColor}
            descriptionKey="interactionDescriptions:pages.products.genericFoodPupop.button.save"
          />
        </CanView>

        {genericFoodEntity && genericFoodEntity.id !== -1 && (
          <>
            <GetSpace right={5} />

            <Button
              label={t("buttons:button_register")}
              typeButton="button"
              type="primary"
              size="medium"
              bgColor={THEME.colors.buttonBGRegisterColor}
              onClick={handleEnableRegister}
              descriptionKey="interactionDescriptions:pages.products.genericFoodPupop.button.register"
            />

            {associationButton}

            <CanView permission={savePermission}>
              {onCopy && (
                <>
                  <GetSpace right={5} />

                  <Button
                    label={t("buttons:button_copy")}
                    typeButton="button"
                    type="primary"
                    size="medium"
                    bgColor={THEME.colors.buttonBGPlusColor}
                    onClick={onCopy}
                    descriptionKey="interactionDescriptions:pages.products.genericFoodPupop.button.copy"
                  />
                </>
              )}
            </CanView>
          </>
        )}

        <CanView permission={savePermission}>
          {genericFoodEntity && genericFoodEntity.id !== -1 && (
            <>
              <GetSpace right={5} />

              <Button
                label={t("buttons:button_remove")}
                typeButton="button"
                type="primary"
                size="medium"
                iconColor={THEME.colors.buttonFGRemoveColor}
                bgColor={THEME.colors.buttonBGRemoveColor}
                onClick={() =>
                  setNewConfirmation(
                    t("general:label_title_remove"),
                    t("general:label_description_remove"),
                    async () => await onRemove(),
                  )
                }
                descriptionKey="interactionDescriptions:pages.products.genericFoodPupop.button.remove"
              />
            </>
          )}
        </CanView>
      </section>

      {isRegisterEnable && genericFoodEntity && (
        <ViewRegister id={genericFoodEntity.id} typeEntity="GenericFoodEntityId" onClose={handleDisableRegister} />
      )}

      {enablePromotion && (
        <ListSelections
          onClinck={handleAddPromotions}
          icon={faRectangleAd}
          listCards={promotionsMemory.getListCards(false)}
          messageCount={t("list:label_promotions_page_message_count")}
          messageEmpty={t("list:label_promotions_page_message_empty")}
          title={t("promotion:label_title_select_promotion")}
          onClonse={() => setPromotion(false)}
        />
      )}

      {enableAddtionals && (
        <ListSelections
          icon={faPlusSquare}
          listCards={addtionalMemory.getListCards(false)}
          title={t("addtional:title_basic")}
          messageCount={t("list:label_addtional_page_message_count")}
          messageEmpty={t("list:label_addtional_page_message_empty")}
          onClinck={(e) => {
            if (addtionalSelectionType === "free") {
              addFreeAddtionals(e)
            } else {
              addAddtionals(e)
            }

            setEnableSelectAdditionals(false)
          }}
          onClonse={() => setEnableSelectAdditionals(false)}
        />
      )}

      {enableSelections && (
        <ListSelections
          icon={faPlusSquare}
          listCards={selectionMemory.getListCards(false)}
          title={t("label_selection_title")}
          messageCount={t("label_selection_count")}
          messageEmpty={t("label_selection_empty")}
          onClinck={(e) => {
            addSelections(e)
            setEnableSelections(false)
          }}
          onClonse={() => setEnableSelections(false)}
        />
      )}
    </>
  )
}
